import * as React from "react";
type Props = {
  className?: string,
};
function SvgChecklist({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-checklist"
      className={className}
    >
      <path
        d="M6.66211 11.9277C9.80664 11.9277 12.418 9.31641 12.418 6.17188C12.418 3 9.80664 0.388672 6.66211 0.388672C3.49023 0.388672 0.892578 3 0.892578 6.17188C0.892578 9.31641 3.50391 11.9277 6.66211 11.9277ZM5.96484 9.33008C5.73242 9.34375 5.56836 9.20703 5.4043 9.01562L3.72266 7.04688C3.61328 6.92383 3.57227 6.78711 3.57227 6.58203C3.57227 6.25391 3.8457 5.9668 4.17383 5.9668C4.39258 5.9668 4.57031 6.0625 4.70703 6.25391L5.9375 7.74414L8.54883 3.61523C8.68555 3.39648 8.89062 3.27344 9.0957 3.27344C9.4375 3.27344 9.72461 3.54688 9.72461 3.86133C9.72461 4.02539 9.66992 4.16211 9.54688 4.33984L6.56641 9.00195C6.42969 9.2207 6.23828 9.34375 5.96484 9.33008ZM16.3691 6.97852H30.2871C30.7383 6.97852 31.0938 6.62305 31.0938 6.17188C31.0938 5.7207 30.7383 5.37891 30.2871 5.37891H16.3691C15.918 5.37891 15.5762 5.7207 15.5762 6.17188C15.5762 6.62305 15.918 6.97852 16.3691 6.97852ZM6.66211 27.9238C9.80664 27.9238 12.418 25.3125 12.418 22.1543C12.418 18.9824 9.80664 16.3848 6.66211 16.3848C3.49023 16.3848 0.892578 18.9961 0.892578 22.1543C0.892578 25.2988 3.50391 27.9238 6.66211 27.9238ZM6.66211 26.3652C4.36523 26.3652 2.45117 24.4375 2.45117 22.1543C2.45117 19.8574 4.36523 17.9297 6.66211 17.9297C8.94531 17.9297 10.873 19.8711 10.873 22.1543C10.873 24.4375 8.94531 26.3652 6.66211 26.3652ZM16.3691 22.9473H30.2871C30.7383 22.9473 31.0938 22.6055 31.0938 22.1543C31.0938 21.6895 30.7383 21.3477 30.2871 21.3477H16.3691C15.918 21.3477 15.5762 21.6895 15.5762 22.1543C15.5762 22.6055 15.918 22.9473 16.3691 22.9473Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgChecklist;
